import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmModalComponent } from './confirm-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {

  constructor(private dialog: MatDialog) { }
  openDialogModal(options: DialogModalOptions): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmModalComponent> = this.dialog.open(ConfirmModalComponent);
    dialogRef.componentInstance.title = options.title.toString();
    dialogRef.componentInstance.message = options.message.toString();
    dialogRef.componentInstance.button = options.button;
    return dialogRef.afterClosed();
  }


}
export interface DialogModalOptions {
  title: string;
  message: string;
  button: { left: string, right: string };
}



